const SEPARATOR_CHARACTER = ":";
export {
  SEPARATOR_CHARACTER
};
//# sourceMappingURL=const.js.map
